import React from 'react';
import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const StudentJourneyNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/report/cro/${userId}`;
  return <NavigationModel redirectUrl={redirectUrl} title="Student Journey" navigationTo={'Old Portal'} />;
};

export default StudentJourneyNavigation;
